import React from 'react'

const IconStarFilled: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width={16} height={16} fill="none" {...props}>
        <path d="M15.034 6.905c.599-.598.25-1.644-.6-1.743l-3.295-.449c-.35-.05-.649-.249-.799-.547l-1.498-2.94c-.4-.746-1.498-.746-1.847.001L5.547 4.215c-.1.3-.4.498-.75.548l-3.245.498c-.849.15-1.198 1.196-.549 1.793L3.4 9.345c.25.25.35.598.3.897l-.5 3.237c-.15.847.749 1.495 1.498 1.096l2.896-1.544c.3-.15.65-.15.949 0l2.946 1.494c.749.399 1.647-.249 1.498-1.095l-.6-3.238a1.1 1.1 0 01.3-.946l2.347-2.341z" />
    </svg>
)

export default IconStarFilled
